import { defineMessages } from "react-intl";
const localized = defineMessages({
  datePickerPlaceholder: {
    id: "datePickerPlaceholder",
    defaultMessage: "Select Date"
  }
});
export {
  localized
};
//# sourceMappingURL=DateSinglePicker.localize.js.map
